import { render, staticRenderFns } from "./RuJiaCulture.vue?vue&type=template&id=27a130d8&scoped=true&"
import script from "./RuJiaCulture.vue?vue&type=script&lang=js&"
export * from "./RuJiaCulture.vue?vue&type=script&lang=js&"
import style0 from "./RuJiaCulture.vue?vue&type=style&index=0&id=27a130d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a130d8",
  null
  
)

export default component.exports